import Accordion from 'entities/Accordion'
import { AccentColorPicker } from 'features/AccentColorPicker'
import { FontPicker } from 'features/FontPicker'
import { ImagesPicker } from 'features/ImagesPicker'
import { LanguagePicker } from 'features/LanguagePicker'
import { ProductsLayout } from 'features/ProductsLayout'
import { ThemeSelector } from 'features/ThemeSelector'

export const LanguagesAccordion = () => {
  return (
    <Accordion title='Languages'>
      <LanguagePicker />
    </Accordion>
  )
}
